export function timeAgo(d: Date | null): string {
    if (!d) return "never";
    const s = Math.floor((Date.now() - d.getTime()) / 1000);
    if (s < 5) return "just now";
    if (s < 60) return `${s}s ago`;
    const m = Math.floor(s / 60);
    if (m < 60) return `${m}m ago`;
    return d.toLocaleTimeString();
}
